import { Link, useNavigate } from 'react-router';
import { ArrowLeft, BookOpen } from 'lucide-react';

interface DocLayoutProps {
  title: string;
  children: React.ReactNode;
}

/**
 * Shared layout for documentation pages.
 */
export function DocLayout({ title, children }: DocLayoutProps) {
  const navigate = useNavigate();

  return (
    <div className="mx-auto max-w-3xl">
      <div className="mb-6 flex items-center gap-4">
        <button
          onClick={() => navigate(-1)}
          className="rounded-lg p-2 text-muted-foreground hover:bg-gray-100"
        >
          <ArrowLeft className="h-5 w-5" />
        </button>
        <div className="flex-1">
          <div className="flex items-center gap-2">
            <BookOpen className="h-5 w-5 text-[var(--vivid-purple)]" />
            <h1 className="text-2xl font-bold" style={{ fontFamily: 'var(--font-primary)' }}>
              {title}
            </h1>
          </div>
          <Link
            to="/staff/documentatie"
            className="mt-0.5 text-xs text-muted-foreground hover:text-[var(--vivid-purple)] hover:underline"
          >
            Documentație
          </Link>
        </div>
      </div>

      <div className="rounded-xl border bg-white p-6 shadow-sm">
        <div className="doc-prose max-w-none text-sm" style={{ fontFamily: 'var(--font-secondary)' }}>
          {children}
        </div>
      </div>
    </div>
  );
}
